import { Component, OnInit } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { NbAuthService } from '@nebular/auth';
import { Router } from '@angular/router';
import { UploadProfilePopupComponent } from '../upload-profile-popup/upload-profile-popup.component';

@Component({
  selector: 'ngx-upload-profile-popup-opener',
  template: '' // No UI
})
export class UploadProfilePopupOpenerComponent implements OnInit {

  constructor(
    private dialogService: NbDialogService,
    private authService: NbAuthService,
    private router: Router,
  ) {}

  ngOnInit() {

    // IMPORTANT: Use getToken() (async)
    this.authService.getToken().subscribe(token => {
      const uid = token?.getValue();

      if (!uid) return;

      // Auto popup open
      this.dialogService.open(UploadProfilePopupComponent, {
        context: { uid },
        closeOnBackdropClick: false,
        closeOnEsc: false
      })
      .onClose.subscribe(done => {
        if (done === true) {
          this.router.navigateByUrl('/');
        }
      });

    });
  }
}
